<template>
  <el-menu class="el-menu-demo2" mode="horizontal">
    <el-submenu index="1">
      <template slot="title">
        <!-- <i class="iconfont icon-more_icon"></i> -->
        <i class="iconfont icon-shezhi"></i>
      </template>
      <el-submenu index="2-4">
        <template slot="title"><i class="iconfont icon-zhuti"></i>主题</template>
        <el-menu-item
          v-for="(item, index) in themeData"
          :key="index"
          @click="changeTheme(item.value, index)"
          :class="{ cur: index === themeCur }"
          :index="item.index"
        >
          <span :class="item.class"></span>
          {{ item.word }}
          <i class="iconfont icon-duihao"></i>
        </el-menu-item>
        <!-- <el-menu-item index="2-4-1" @click="changeTheme('q')">
					主题1 <span class="theme1"></span>
				</el-menu-item>
				<el-menu-item index="2-4-2" @click="changeTheme('s')">
					主题2 <span class="theme2"></span>
				</el-menu-item> -->
      </el-submenu>
      <el-submenu index="2-5">
        <template slot="title"><i class="iconfont icon-zihao"></i>字号</template>
        <el-menu-item
          v-for="(item, index) in fontSizeData"
          :key="index"
          @click="changeFontSize(item.value, index)"
          :class="{ cur: index === fontCur }"
          :index="item.index"
        >
          {{ item.word }}
          <i class="iconfont icon-duihao"></i>
        </el-menu-item>
      </el-submenu>
      <el-menu-item
        index="2-1"
        @click="exit"
        v-if="token"
        style="padding-left: 24px; margin: 0; text-align: left"
      >
        <template slot="title"
          ><i class="iconfont icon-tuichu"></i>退出
          <!-- 该iconfont用来占位 -->
          <i
            class="iconfont"
            style="display: inline-block; width: 12px; height: 12px"
          ></i>
        </template>
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  data() {
    return {
      token: "", //登录token

      //字号====
      fontSize: "", //字号
      fontSizeData: [
        //字号数据
        {
          value: "d",
          word: "大",
          index: "2-5-1",
        },
        {
          value: "z",
          word: "中",
          index: "2-5-2",
        },
        {
          value: "x",
          word: "小",
          index: "2-5-3",
        },
      ],
      fontCur: 0, //当前字号索引值

      //主题===
      theme: "", //主题
      themeData: [
        //主题数据
        {
          value: "s",
          word: "学术蓝",
          index: "2-4-1",
          class: "theme1",
        },
        {
          value: "q",
          word: "科技蓝",
          index: "2-4-2",
          class: "theme2",
        },
        {
          value: "r",
          word: "新年红",
          index: "2-4-3",
          class: "theme3",
        },
        {
          value: "g",
          word: "清新绿",
          index: "2-4-4",
          class: "theme4",
        },
      ],
      themeCur: 0, //主题当前索引值
    };
  },
  created() {
    this.token = window.localStorage.getItem("token");
    //先获取主题和字号，若存在则赋值，否则为初始值
    if (
      window.localStorage.getItem("theme") &&
      window.localStorage.getItem("theme") != "null"
    ) {
      this.theme = window.localStorage.getItem("theme");
      window.document.documentElement.setAttribute("data-theme", this.theme);
      if (this.theme == "s") {
        this.themeCur = 0;
      } else if (this.theme == "q") {
        this.themeCur = 1;
      } else if (this.theme == "r") {
        this.themeCur = 2;
      } else if (this.theme == "g") {
        this.themeCur = 3;
      }
    } else {
      this.theme = "s";
      this.themeCur = 0;
    }
    if (
      window.localStorage.getItem("fontSize") &&
      window.localStorage.getItem("theme") != "null"
    ) {
      this.fontSize = window.localStorage.getItem("fontSize");
      if (this.fontSize == "d") {
        this.fontCur = 0;
      } else if (this.fontSize == "z") {
        this.fontCur = 1;
      } else {
        this.fontCur = 2;
      }
      window.document.documentElement.setAttribute("data-fz", this.fontSize);
    } else {
      this.fontSize = "d";
      this.fontCur = 0;
    }
  },
  methods: {
    //切换主题
    changeTheme(theme, index) {
      this.themeCur = index;
      window.localStorage.setItem("theme", theme); //将主题保存在localStorage中
      this.theme = theme;
      window.document.documentElement.setAttribute("data-theme", theme);
    },
    //切换字号
    changeFontSize(size, index) {
      this.fontCur = index;
      window.localStorage.setItem("fontSize", size); //将字号保存在localStorage中
      this.fontSize = size;
      window.document.documentElement.setAttribute("data-fz", size);
    },
    //退出
    exit() {
      this.axios.get("/japi/user/logout/").then((res) => {
        //删除cookie
        setParentCookie("c_m_LinID","")
        setParentCookie("Ecp_LoginStuts","")
        setParentCookie("Ecp_ClientId","")
        setParentCookie("LID","")
        console.log("退出成功======");
        if (res.data.code == 200) {
          console.log(res);
          let theme = window.localStorage.getItem("theme");
          let fontSize = window.localStorage.getItem("fontSize");
          window.localStorage.clear();
          // this.Cookies.remove('c_m_LinID');//清空存储的值

          //跳转页面刷新
          // console.log(this.$route.path);
          if (this.$route.path == "/legislateKnowledgeBase") {
            this.$router.push("/refresh");
          } else {
            this.$router.push("/legislateKnowledgeBase");
          }
          // this.$router.push("/login");

          //避免切换主题之后再登录，主题选中紊乱
          window.localStorage.setItem("theme", theme);
          window.localStorage.setItem("fontSize", fontSize);
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.el-menu--horizontal .el-menu .el-menu-item i {
  font-size: 15px !important;
}
</style>
